export const SUCCESS_MESSAGE = 'Success.';
export const RATE_DELETED = 'Rate has been deleted.';
// Must exactly match IGNORED_MESSAGE in ../../plans/edit/csv/constants.jsx —
// the shared VerifyCSVTableView component (used by both CSV features)
// buckets "unchanged" rows by comparing verificationStatus against that
// constant specifically, not this file's.
export const RATE_UNCHANGED = 'Ignored, no changes detected.';
export const CSV_TYPE = 'text/csv';
export const CSV_TYPE_FX = 'application/vnd.ms-excel';
export const CSV_TYPE_ERROR = 'File must be .csv type';
export const RATE_DNE_ERROR = 'This rate ID does not exist.';
export const REQUIRED_FIELDS_ERROR = 'Required fields missing';
export const INVALID_NUMERIC_ERROR = 'Must be a valid number';
export const INVALID_ACTIVE_ERROR =
    'Active is invalid — choose either 0 (delete) or 1 (add/edit).';

export const FIELDS_TO_EXPORT = {
    id: 'Rate ID',
    country: 'Country',
    name: 'Name',
    prefix: 'Prefix',
    priority: 'Priority',
    minPrice: 'Minimum Cost',
    flagFallInRate: 'Flag Fall In Rate',
    flagFallOutRate: 'Flag Fall Out Rate',
    inboundRate: 'Inbound Rate',
    outboundRate: 'Outbound Rate',
    isActive: 'Active',
};

// All fields are required except Rate ID and Active (Active defaults to 1 for new rates)
export const REQUIRED_CSV_FIELDS = [
    'country',
    'name',
    'prefix',
    'priority',
    'minPrice',
    'flagFallInRate',
    'flagFallOutRate',
    'inboundRate',
    'outboundRate',
];

export const NUMERIC_FIELDS = [
    'priority',
    'minPrice',
    'flagFallInRate',
    'flagFallOutRate',
    'inboundRate',
    'outboundRate',
];

export const TEMPLATE_FILENAME = 'InternationalRatesTemplate.csv';
export const INVALID_DATA_FILENAME = 'InvalidInternationalRates.csv';
export const FAILED_API_FILENAME = 'FailedInternationalRates.csv';

export const VERIFICATION_CHECKS_INITIAL = [
    { label: 'Received CSV', check: false, current: true },
    { label: 'Fetching Existing Rates', check: false, current: false },
    { label: 'Converting CSV Headers', check: false, current: false },
    { label: 'Verifying Required Fields', check: false, current: false },
    { label: 'Validating Rate Fields', check: false, current: false },
];

export const DEFAULT_VERIFICATION_RESULT = {
    passed: { columns: [], data: [] },
    failed: { columns: [], data: [] },
};

// These feed AGGridMain's columnDefs prop, so they must be real AG Grid
// column definitions (headerName/cellRenderer), not a different table
// library's shape (title/render) — otherwise custom rendering (and
// tooltips) on the error columns below silently never apply.
const sharedColumns = [
    { headerName: 'Country', field: 'country' },
    { headerName: 'Name', field: 'name' },
    { headerName: 'Prefix', field: 'prefix' },
    { headerName: 'Priority', field: 'priority' },
    { headerName: 'Minimum Cost', field: 'minPrice' },
    { headerName: 'Flag Fall In Rate', field: 'flagFallInRate' },
    { headerName: 'Flag Fall Out Rate', field: 'flagFallOutRate' },
    { headerName: 'Inbound Rate', field: 'inboundRate' },
    { headerName: 'Outbound Rate', field: 'outboundRate' },
];

export const passedColumns = [
    ...sharedColumns,
    { headerName: 'Verification Status', field: 'verificationStatus' },
];

const errorCellRenderer = (params) => {
    if (Array.isArray(params.value) && params.value.length > 0) {
        return (
            <span style={{ whiteSpace: 'pre-line' }}>
                {params.value.join('\n')}
            </span>
        );
    }
    return null;
};

const errorTooltipValueGetter = (params) =>
    Array.isArray(params.value) ? params.value.join('\n') : '';

export const failedColumns = [
    ...sharedColumns,
    {
        headerName: 'Failure Reasons',
        field: 'errors',
        flex: 1,
        cellRenderer: errorCellRenderer,
        tooltipValueGetter: errorTooltipValueGetter,
    },
];

export const succeedAPIColumns = [
    { headerName: 'Country', field: 'country' },
    { headerName: 'Name', field: 'name' },
];

export const failedAPIColumns = [
    { headerName: 'Country', field: 'country' },
    { headerName: 'Name', field: 'name' },
    {
        headerName: 'Failure Reasons',
        field: 'apiErrors',
        flex: 1,
        cellStyle: { whiteSpace: 'pre-line' },
        tooltipValueGetter: (params) => params.value ?? '',
    },
];
